<template>
  <div class="main" :style="{'minHeight': mainHeight}">
    <img class="step" :src="stepPic[step - 1]"/>
    <el-form v-if="step === 1" :inline="true" class="stepForm" ref="stepForm1" :rules="dataRule1" :model="formData1">
      <h2>Create your ID</h2>
      <h4>This is step {{step}} of 3</h4>
      <el-form-item prop="firstName">
        <el-input class="customInp-small" v-model="formData1.firstName" placeholder="First name"></el-input>
      </el-form-item>
      <el-form-item prop="lastName">
        <el-input class="customInp-small" v-model="formData1.lastName" placeholder="Last name"></el-input>
      </el-form-item>
      <el-form-item prop="primaryEmail">
        <el-input class="customInp-small" v-model="formData1.primaryEmail" placeholder="Primary email"></el-input>
      </el-form-item>
      <el-form-item prop="additionalEmail">
        <el-input class="customInp-small" v-model="formData1.additionalEmail" placeholder="Additional email (optional)"></el-input>
      </el-form-item>
      <div class="back_btn" @click="handleBack">GO BACK</div>
    </el-form>
    <el-form v-else-if="step === 2" :inline="true" class="stepForm" ref="stepForm2" :rules="dataRule2" :model="formData2">
      <h2>Create your ID</h2>
      <h4>This is step {{step}} of 3</h4>
      <el-form-item prop="password">
        <el-input class="customInp-small" v-model="formData2.password" placeholder="Password" show-password></el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input class="customInp-small" v-model="formData2.confirmPassword" placeholder="Confirm password" show-password></el-input>
      </el-form-item>
      <div class="back_btn" @click="handleBack">GO BACK</div>
    </el-form>
    <el-form v-else-if="step === 3" :inline="true" class="stepForm stepForm3" ref="stepForm3" :rules="dataRule3" :model="formData3" label-width="125px" label-position="left" :hide-required-asterisk="true">
      <h2>Edit personal information</h2>
      <h4 style="margin-bottom: 0;">This is step {{step}} of 3</h4>
      <h6 style="margin: 5px 0;">Please enter your personal information below. Required fields are in color.</h6>
      <h4><b>Primary Contact Information&nbsp;&nbsp;&nbsp;&nbsp;Last modified: {{new Date().toDateString()}}</b></h4>
      <el-form-item label="First Name:" prop="firstName">
        <el-input class="customInp-small customInp-small-dark" v-model="formData1.firstName" disabled></el-input>
      </el-form-item>
      <el-form-item label="Middle Name(or Initial):" prop="middleName" label-width="180px">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.middleName"></el-input>
      </el-form-item>
      <el-form-item label="Last Name:" prop="lastName">
        <el-input class="customInp-small customInp-small-dark" v-model="formData1.lastName" disabled></el-input>
      </el-form-item>
      <el-form-item></el-form-item>
      <el-form-item label="Institution:" prop="institution" style="width: 97.5%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.institution"></el-input>
      </el-form-item>
      <el-form-item label="Department:" prop="department" style="width: 97.5%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.department"></el-input>
      </el-form-item>
      <el-form-item label="Suffix:" prop="suffix">
        <el-select class="customInp-small customInp-small-dark" v-model="formData3.suffix" placeholder="None">
          <el-option v-for="item in suffixList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item></el-form-item>
      <el-form-item label="Institutional Email/URL:" prop="institutionalEmail" label-width="185px" style="width: 97.5%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.institutionalEmail" style="width: 420px;"></el-input>
        <div class="tips">
          Please provide an institutional email address or website URL for your research group or institution. This may be used for verification. Include telephone extension in the "phone number" field
        </div>
      </el-form-item>
      <div style="line-height: 40px;">
        <span style="display: inline-block;font-weight: bold;width: 115px;text-align: left;font-size: 14px;">Telephone:</span>
        <div style="display: inline-block;width: calc(100% - 130px)">
          <el-form-item label="Country Code" prop="counteyCode" style="width: 31%;">
            <el-input class="customInp-small customInp-small-dark" v-model="formData3.counteyCode"></el-input>
          </el-form-item>
          <el-form-item label="Area code" prop="areaCode" style="width: 31%;">
            <el-input class="customInp-small customInp-small-dark" v-model="formData3.areaCode"></el-input>
          </el-form-item>
          <el-form-item label="Phone number" prop="phoneNumber" style="width: 31%;">
            <el-input class="customInp-small customInp-small-dark" v-model="formData3.phoneNumber"></el-input>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="Address:" prop="address" style="width: 65%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.address"></el-input>
      </el-form-item>
      <el-form-item label="City:" prop="city" label-width="135px" style="width: 31%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.city"></el-input>
      </el-form-item>
      <el-form-item label="State/Province:" prop="state" style="width: 65%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.state"></el-input>
      </el-form-item>
      <el-form-item label="ZIP/Postal Code:" prop="postalCode" label-width="135px" style="width: 31%;">
        <el-input class="customInp-small customInp-small-dark" v-model="formData3.postalCode"></el-input>
      </el-form-item>
      <el-form-item label="Country:" prop="country">
        <el-select class="customInp-small customInp-small-dark" v-model="formData3.country" placeholder="None" filterable>
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item></el-form-item>
    </el-form>
    <div class="next_btn" @click="handleNext">NEXT</div>
  </div>
</template>

<script>
import { cityList } from '@/utils/index'
export default {
  name: 'register',
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter confirm password'))
      } else if (value !== this.formData2.password) {
        callback(new Error('The two passwords are inconsistent'))
      } else {
        callback()
      }
    }
    return {
      mainHeight: 0,
      step: 1,
      stepPic: [
        require('../../static/img/register-step-1.png'),
        require('../../static/img/register-step-2.png'),
        require('../../static/img/register-step-3.png')
      ],
      formData1: {
        firstName: '',
        lastName: '',
        primaryEmail: '',
        additionalEmail: ''
      },
      dataRule1: {
        firstName: [
          { required: true, message: 'Please enter first name', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Please enter last name', trigger: 'blur' }
        ],
        primaryEmail: [
          { required: true, message: 'Please enter primary email', trigger: 'blur' },
          { type: 'email', message: 'Please enter the correct primary email', trigger: 'blur' }
        ],
        additionalEmail: [
          { type: 'email', message: 'Please enter the correct additional email', trigger: 'blur' }
        ]
      },
      formData2: {
        password: '',
        confirmPassword: ''
      },
      dataRule2: {
        password: [
          { required: true, message: 'Please enter password', trigger: 'blur' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, message: 'The length shall be at least 8 and contain at least one letter and one number', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, message: 'The length shall be at least 8 and contain at least one letter and one number', trigger: 'blur' }
        ]
      },
      formData3: {
        middleName: '',
        institution: '',
        department: '',
        suffix: '',
        institutionalEmail: '',
        counteyCode: '',
        areaCode: '',
        phoneNumber: '',
        address: '',
        city: '',
        state: '',
        postalCode: '',
        country: ''
      },
      dataRule3: {
        institution: [
          { required: true, message: 'Please enter institution', trigger: 'blur' }
        ],
        department: [
          { required: true, message: 'Please enter department', trigger: 'blur' }
        ],
        suffix: [
          { required: true, message: 'Please enter suffix', trigger: 'blur' }
        ],
        institutionalEmail: [
          { required: true, message: 'Please enter institutional Email/URL', trigger: 'blur' },
          { max: 200, message: '', trigger: 'blur' }
        ],
        counteyCode: [
          { required: true, message: 'Please enter country code', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: 'Please enter area code', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: 'Please enter phone number', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Please enter address', trigger: 'blur' }
        ],
        city: [
          { required: true, message: 'Please enter city', trigger: 'blur' }
        ],
        state: [
          { required: true, message: 'Please enter state/province', trigger: 'blur' }
        ],
        postalCode: [
          { required: true, message: 'Please enter ZIP/postal code', trigger: 'blur' }
        ],
        country: [
          { required: true, message: 'Please enter country', trigger: 'blur' }
        ]
      },
      suffixList: [
        'Mr.',
        'Mrs.',
        'Ms.',
        'Miss.',
        'Dr.',
        'Professor.'
      ],
      cityList: []
    }
  },
  mounted () {
    this.$nextTick(() => this.setWindowHeight())
    this.cityList = cityList()
  },
  methods: {
    setWindowHeight () {
      var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

      var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

      this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')

      window.addEventListener('resize', function () {
        var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

        var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

        this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')
      }.bind(this))
    },

    handleBack () {
      if (this.step === 1) {
        this.$router.replace('home')
      } else if (this.step === 2) {
        this.$refs['stepForm2'].clearValidate()
        this.step = 1
      }
    },

    handleNext () {
      if (this.step === 1) {
        this.$refs.stepForm1.validate(valid => {
          if (valid) {
            this.step = 2
          }
        })
      } else if (this.step === 2) {
        this.$refs.stepForm2.validate(valid => {
          if (valid) {
            this.step = 3
          }
        })
      } else if (this.step === 3) {
        this.$refs.stepForm3.validate(valid => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl('/sys/userapply'),
              method: 'post',
              data: this.$http.adornData({
                ...this.formData1,
                ...this.formData2,
                ...this.formData3
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message.success('Register successfully')
                this.$router.replace('home')
              } else {
                this.$message.error(data.msg)
                if (data.msg === 'This email has been registered, please sign in！') {
                  this.step = 1
                }
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../../static/img/background.png") no-repeat;
    background-size: 100% 100%;
    /*justify-content: center;*/
  }
  .step {
    width: 27.5%;
    margin: 25px 0;
  }
  .stepForm {
    width: 55%;
    min-width: 1020px;
    padding: 30px 30px 80px 30px;
    background: url("../../static/img/bg-register.png") no-repeat;
    background-size: 100% 100%;
    color: #492500;
    box-sizing: border-box;
  }
  .stepForm h2 {
    margin: 10px 0;
    font-size: 30px;
  }
  .stepForm h4 {
    margin: 0 0 30px 0;
    font-weight: normal;
    font-size: 15px;
  }
  .stepForm h6 {
    margin: 0;
    font-weight: normal;
    font-size: 12px;
  }
  * /deep/ .customInp-small input {
    background: #C8D256;
    border: 1px solid white;
    font-size: 20px;
    color: white;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
  }
  * /deep/ .customInp-small-dark input {
    background: #939D31;
    font-size: 13px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }
  .stepForm >>> .el-form-item {
    width: 48%;
  }
  .stepForm >>> .el-form-item__content {
    width: 100%;
  }
  * /deep/ .customInp-small input::-webkit-input-placeholder {
    color: #FFFFFF;
  }
  * /deep/ .customInp-small input::-moz-placeholder {
    color: #FFFFFF;
  }
  * /deep/ .customInp-small input:-ms-input-placeholder {
    color: #FFFFFF;
  }
  .back_btn {
    display: inline-block;
    float: right;
    cursor: pointer;
    color: white;
    background: #6F7B08;
    font-size: 15px;
    font-weight: bold;
    padding: 6px 20px;
    border: 1px solid white;
    border-radius: 20px;
    margin-right: 15px;
    transition: all 0.1s;
  }
  .next_btn {
    cursor: pointer;
    color: white;
    background: #b1be54;
    font-size: 24px;
    font-weight: bold;
    padding: 5px 30px;
    border: 2px solid white;
    border-radius: 20px;
    box-shadow: 0 8px 5px #6F7B08;
    margin: 20px 0 40px 0;
    transition: all 0.1s;
  }
  .back_btn:hover,
  .next_btn:hover {
    transform: scale(1.1)
  }
  .stepForm3 >>> .el-form-item {
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 10px;
  }
  .stepForm3 >>> .el-form-item__label {
    font-size: 15px;
    font-weight: bold;
    color: #492500;
    flex-shrink: 0;
  }
  .stepForm >>> .el-form-item__content {
    text-align: left;
  }
  .stepForm3 >>> .el-input__inner {
    width: 100%;
  }
  * /deep/ .el-select .el-input__inner:focus {border-color: #fff}
  * /deep/ .el-select .el-input .el-select__caret {
    color: #fff;padding: 0 6px;
    background: #492500;
    height: 27.5px;margin-right: -4px;
    line-height: 27.5px;
    margin-top: 7.5px;
    transition: 0s;
    border-radius: 30px 0 0 30px;
  }
  * /deep/ .el-select .el-input .el-select__caret.is-reverse {
    border-radius: 0 30px 30px 0;
  }
  .stepForm3 .tips {
    width: 420px;
    font-size: 12px;
    line-height: 20px;
  }
  * /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #b1be54;
    border-color: #E4E7ED;
    color: #eee;
  }
  * /deep/ .el-input .el-input__clear {
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/register.vue